module.exports = __webpack_public_path__ + "img/chr_ts_90_6.3019ceee.png";